import reportApi from '@/api/report';

const state = {
    isLoading: false,
    validationErrors: null,
    revenue: null,
    sales: null
}

export const mutationTypes = {
    revenueDivisionStart: '[revenue] Revenue division start',
    revenueDivisionSuccess: '[revenue] Revenue division success',
    revenueDivisionFailure: '[revenue] Revenue division failure',

    salesPlanfactStart: '[sales] Sales planfact start',
    salesPlanfactSuccess: '[sales] Sales planfact success',
    salesPlanfactFailure: '[sales] Sales planfact failure',
}

export const reportActionTypes = {
    revenueDivision: '[revenue] Revenue division',
    salesPlanfact: '[sales] Sales planfact',
}

const mutations = {
    [mutationTypes.revenueDivisionStart](state) {
        state.isLoading = true
        state.revenue = null
    },
    [mutationTypes.revenueDivisionSuccess](state, payload) {
        state.isLoading = false
        state.revenue = payload
        state.validationErrors = null
    },
    [mutationTypes.revenueDivisionFailure](state, payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.salesPlanfactStart](state) {
        state.isLoading = true
        state.sales = null
    },
    [mutationTypes.salesPlanfactSuccess](state, payload) {
        state.isLoading = false
        state.sales = payload
        state.validationErrors = null
    },
    [mutationTypes.salesPlanfactFailure](state, payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
}

const actions = {
    [reportActionTypes.revenueDivision](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.revenueDivisionStart)
            reportApi
                .revenueDivision(data)
                .then(response => {
                    context.commit(mutationTypes.revenueDivisionSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.revenueDivisionFailure, response)
                })
        })
    },
    [reportActionTypes.salesPlanfact](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.salesPlanfactStart)
            reportApi
                .salesPlanfact(data)
                .then(response => {
                    context.commit(mutationTypes.salesPlanfactSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.salesPlanfactFailure, response)
                })
        })
    }
}

export default {
    state,
    actions,
    mutations
}